// Hack : Apres une montée de version de typescript (donc d'angular) le type Omit sera natif a typescript
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

